import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthComponent } from "./auth-section/auth/auth.component";
import { HomeComponent } from "./home-section/home/home.component";
import { AuthguardService } from "./auth-section/auth-service/authguard.service";
import { DoctorsRegisterComponent } from "./doctor-section/doctors-register/doctors-register.component";
import { DoctorsComponent } from "./doctor-section/doctors/doctors.component";
import { DoctypeComponent } from "./doctype-section/doctype/doctype.component";
import { PatientsComponent } from "./patient-section/patients/patients.component";
import { PatientsRegisterComponent } from "./patient-section/patients-register/patients-register.component";
import { SinglepatientComponent } from "./patient-section/single-patient/singlepatient/singlepatient.component";
import { SingledoctorComponent } from "./doctor-section/single-doctor/singledoctor/singledoctor.component";
import { AppointmentComponent } from "./appointment-section/appointment/appointment/appointment.component";
import { HospitalComponent } from "./hospital-section/hospital/hospital.component";
import { HospitalRegisterComponent } from "./hospital-section/hospital-register/hospital-register.component";
import { HospitalDoctorsComponent } from "./hospital-section/hospital-doctors/hospital-doctors.component";
import { HospitaldocregComponent } from "./hospital-section/hospital-doctors/hospitaldoc-register/hospitaldocreg/hospitaldocreg.component";
import { HosdocprofileComponent } from "./hospital-section/hospital-doctors/hosdocProfile/hosdocprofile/hosdocprofile.component";
import { LogoutGuardService } from "./auth-section/auth-service/logout-guard.service";
import { PatientAppointmentComponent } from "./appointment-section/patient-appointment/patient-appointment/patient-appointment.component";
import { HospitalimagesComponent } from "./hospital-section/hospital-images/hospitalimages/hospitalimages.component";
import { AdComponent } from "./ad-section/ad/ad.component";
import { LabComponent } from "./lab-section/lab/lab.component";
import { AddlabComponent } from "./lab-section/addlab/addlab.component";
import { FeaturesComponent } from "./feature-section/features/features.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "/pas",
    pathMatch: "full",
  },
  {
    path: "auth",
    component: AuthComponent,
    pathMatch: "full",
    canActivate: [LogoutGuardService],
  },

  {
    path: "pas",
    pathMatch: "full",
    component: HomeComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/doctors",
    pathMatch: "full",
    component: DoctorsComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/feature",
    pathMatch: "full",
    component: FeaturesComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/doctors/register",
    pathMatch: "full",
    component: DoctorsRegisterComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/patients",
    pathMatch: "full",
    component: PatientsComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/patients/register",
    pathMatch: "full",
    component: PatientsRegisterComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/patients/profile",
    pathMatch: "full",
    component: SinglepatientComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/doctors/profile",
    pathMatch: "full",
    component: SingledoctorComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/hospital/register",
    pathMatch: "full",
    component: HospitalRegisterComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/hospital/update",
    pathMatch: "full",
    component: HospitalRegisterComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/hospital",
    pathMatch: "full",
    component: HospitalComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/hospital/addimages",
    pathMatch: "full",
    component: HospitalimagesComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/hospital/doctors",
    pathMatch: "full",
    component: HospitalDoctorsComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/hospital/doctors/profile",
    pathMatch: "full",
    component: HosdocprofileComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/hospital/doctors/register",
    pathMatch: "full",
    component: HospitaldocregComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/doctype",
    pathMatch: "full",
    component: DoctypeComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/doctors/appointments",
    pathMatch: "full",
    component: AppointmentComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/patients/appointments",
    pathMatch: "full",
    component: PatientAppointmentComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/advertisement/addads",
    pathMatch: "full",
    component: AdComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/advertisement/ads",
    pathMatch: "full",
    component: AdComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/lab",
    pathMatch: "full",
    component: LabComponent,
    canActivate: [AuthguardService],
  },
  {
    path: "pas/lab",
    pathMatch: "full",
    component: LabComponent,
    canActivate:[AuthguardService]
    },
  {
    path: "pas/lab/addlab",
    pathMatch: "full",
    component: AddlabComponent,
    canActivate: [AuthguardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
